if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', () => this.hide());
      this.addEventListener('click', event => {
        if (event.target === this) this.hide();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.hide();
        }
        if (event.key !== 'Tab') return;
        const controls = Array.from(this.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"], video[controls]'))
          .filter(element => element.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      });
    }

    show(opener) {
      if (!opener) return;
      this.openedBy = opener;
      this.previousOverflow = document.body.style.overflow;
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      const id = opener.getAttribute('data-media-id');
      const media = Array.from(this.querySelectorAll('[data-media-id]'));
      const active = media.find(element => element.getAttribute('data-media-id') === id) || media[0];
      media.forEach(element => element.classList.toggle('active', element === active));
      const container = this.querySelector('[role="document"]');
      if (container && active) {
        container.scrollTop = active.offsetTop - container.offsetTop;
        container.scrollLeft = Math.max(0, (active.clientWidth - container.clientWidth) / 2);
      }
      this.querySelector('[id^="ModalClose-"]')?.focus({ preventScroll: true });
    }

    hide() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.body.style.overflow = this.previousOverflow || '';
      this.querySelectorAll('video').forEach(video => video.pause());
      this.openedBy?.focus({ preventScroll: true });
    }
  });
}
